import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogOut = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.1665 2.33268C2.94549 2.33268 2.73353 2.42048 2.57725 2.57676C2.42097 2.73304 2.33317 2.945 2.33317 3.16602V14.8327C2.33317 15.0537 2.42097 15.2657 2.57725 15.4219C2.73353 15.5782 2.94549 15.666 3.1665 15.666H6.49984C6.96007 15.666 7.33317 16.0391 7.33317 16.4993C7.33317 16.9596 6.96007 17.3327 6.49984 17.3327H3.1665C2.50346 17.3327 1.86758 17.0693 1.39874 16.6005C0.929896 16.1316 0.666504 15.4957 0.666504 14.8327V3.16602C0.666504 2.50297 0.929896 1.86709 1.39874 1.39825C1.86758 0.929408 2.50346 0.666016 3.1665 0.666016H6.49984C6.96007 0.666016 7.33317 1.03911 7.33317 1.49935C7.33317 1.95959 6.96007 2.33268 6.49984 2.33268H3.1665Z",
			fill: "#FD6460"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.7439 4.24343C12.0694 3.91799 12.597 3.91799 12.9224 4.24343L17.0891 8.41009C17.4145 8.73553 17.4145 9.26317 17.0891 9.5886L12.9224 13.7553C12.597 14.0807 12.0694 14.0807 11.7439 13.7553C11.4185 13.4298 11.4185 12.9022 11.7439 12.5768L15.3213 8.99935L11.7439 5.42194C11.4185 5.0965 11.4185 4.56886 11.7439 4.24343Z",
			fill: "#FD6460"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.6665 8.99935C5.6665 8.53911 6.0396 8.16602 6.49984 8.16602H16.4998C16.9601 8.16602 17.3332 8.53911 17.3332 8.99935C17.3332 9.45959 16.9601 9.83268 16.4998 9.83268H6.49984C6.0396 9.83268 5.6665 9.45959 5.6665 8.99935Z",
			fill: "#FD6460"
		})
	]
});
export default SvgLogOut;
